import { Flex, Text, TextArea } from '@scale/scaleui-radix';

export const FillCriterionJustification = ({
  feedback,
  setFeedback,
  required,
  disabled,
}: {
  feedback: string;
  setFeedback: (feedback: string) => void;
  required: boolean;
  disabled: boolean;
}) => {
  return (
    <Flex direction="column" gap="2">
      <Flex direction="row" gap="2">
        <Text weight="medium">Feedback</Text>
        {required && !disabled && (
          <Text size="2" color="red">
            *
          </Text>
        )}
      </Flex>
      <TextArea
        size="2"
        value={feedback}
        onChange={e => setFeedback(e.target.value)}
        disabled={disabled}
      />
    </Flex>
  );
};
